import * as Sentry from '@sentry/browser'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import { Button } from '../Button'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    // Surface the crash to Sentry, but only when Sentry was actually initialized
    // (gated by the same flag in App.jsx) so we don't warn when it's disabled
    if (import.meta.env.VITE_SENTRY_ENABLED === 'true') {
      Sentry.captureException(error, { extra: { componentStack: info?.componentStack } })
    }
  }

  tryAgain = () => this.setState({ error: null })

  render() {
    if (!this.state.error) {
      return this.props.children
    }

    return (
      <div className="flex size-full flex-col items-center justify-center space-y-3 p-8 text-center">
        <ExclamationCircleIcon className="size-10 text-error-icon" aria-hidden="true" />

        <span className="text-2xl font-bold">Something went wrong</span>
        <span className="max-w-md text-sm text-gray-600">
          This page hit an unexpected error. You can try again, or use the navigation to move to
          another page.
        </span>

        <div className="flex flex-row gap-2">
          <Button onClick={this.tryAgain} type="button" label="Try Again" />
          <Button
            onClick={() => window.location.reload()}
            type="button"
            background="bg-gray"
            label="Reload Page"
          />
        </div>
      </div>
    )
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ErrorBoundary
